<div class="profile-content test-container test-view" *ngIf="currentTest" >
  <!--TODO: Do I need to show revise button? -->
  <section class="test-view-bar">
    <header *ngIf="!isPatientContext && !isCustomConfig" class="header profile-header test-view-header bottom-header-shade">
      <div class="Flexbox">
        <div class="header-content contnet-filters Flexbox Flexbox__flex-1 fs5">
          <gen-test-header-elements class="content-item Flexbox Spacebox__lr-small patient-profile profile-header-section">
          </gen-test-header-elements>
        </div>
      </div>
    </header>
    <gen-test-bar *ngIf="!verticalLeftContainerPatientView && !patientWithoutTests"
                  [currentTest]="currentTest"
                  [currentWorkflow]="workflowRequest$ | async"
                  [currentRevision]="currentRevision$ | async"
                  [contextName]="contextName$ | async"
                  [showRevise]="false"
                  [newNotes]="newNotesCount"
                  [latestRevisionId]="latestWorfklowRevisionId$ | async"
                  (notesPanelOpened)="notesPanelOpened()"
                  [testInWorklist]="testInWorklist$ | async"
                  [infoOrigin]="headerInfoSource$ | async"
                  [isCustomConfig]="isCustomConfig"
                  [customRevisionData]="customRevisionData"
                  [patientAnalyses]="patientAnalyses"
                  [isPatientEditable]="patient"
                  [isAttachmentEnabled]="isAttachmentEnabled">
    </gen-test-bar>
  </section>

  <section class="test-view-tabs" *ngIf="!patientWithoutTests">
    <gen-notes-side-panel (newNotesChange)="updateNotes($event)"
                          [contextId]="contextId"
                          [actorId]="currentUser.info.id"
                          ([newNotes])="newNotesCount"
                          [actorType]="'Practitioner'"
                          [contextType]="contextType"
                          [contextObject]="contextObject">
    </gen-notes-side-panel>
    <gen-attachment
      [currentRevision]="currentRevision$ | async"
      [testNumber]="currentTest.identifiers[0].value"
      [workflowId]="workflowId"
      (documentsLoaded)="enableAttachment($event)">
    </gen-attachment>
      <gen-test-tab *ngIf="!isCustomConfig"
                    [originalStateName]="originalStateName"
                    [activeWorkflowConfirmationButton]="activeWorkflowConfirmationButton"
                    [isChecklistTabPresent]="isChecklistTabPresent"
                    [pageReload]="pageReload">
      </gen-test-tab>
      <gen-test-custom-tab *ngIf="isCustomConfig"
                           [currentRevision]="customRevisionData"
                           [patientAnalyses]="patientAnalyses">
      </gen-test-custom-tab>
     <div class="Flexbox Flexbox_rows height">
      <!-- add the the upper call height:100% -->
       <ispm-curation-navigation-vertical-container class="side-container" *ngIf="verticalLeftContainerPatientView">
           <ispm-curation-navigation-pathway-execution
                   class="navigation-pathway"
                   [currentTest]="currentTest"
                   [currentWorkflow]="workflowRequest$ | async"
                   [currentRevision]="currentRevision$ | async"
                   [contextName]="contextName$ | async"
                   [newNotes]="newNotesCount"
                   [latestRevisionId]="latestWorfklowRevisionId$ | async"
                   [testInWorklist]="testInWorklist$ | async"
                   [infoOrigin]="headerInfoSource$ | async"
                   [isPatientContext]="isPatientContext"
           ></ispm-curation-navigation-pathway-execution>
       </ispm-curation-navigation-vertical-container>
       <div class="tab-content main-ui">
         <div class="tab-pane active" [ngClass]="{'extra-height': !!verticalLeftContainerPatientView, 'fixed-height': isFixedHeightTabPane}">
             <router-outlet></router-outlet>
         </div>
         <gen-overlay-loader *ngIf="testService.prefetchInProgress" [loaderType] = "'SKELETON-PLAIN'" [showOverlay]="false"></gen-overlay-loader>
       </div>
     </div>
  </section>
</div>
